import { useSuspenseQuery } from '@tanstack/react-query';

import { Id } from '@feature/utils';
import { ValidationHistoryContent } from '@feature/validation/ValidationHistoryContent';

import { getResearchPerfEvalItemValidationHistoryOptions } from './model/ResearchPerfEvalItemValidationModel';

interface ResearchPerfEvalItemValidationHistoryProps {
  itemId: Id;
  defaultIsCollapsed?: boolean;
}

export function ResearchPerfEvalItemValidationHistory({
  itemId,
  defaultIsCollapsed,
}: ResearchPerfEvalItemValidationHistoryProps) {
  const { data: history } = useSuspenseQuery(getResearchPerfEvalItemValidationHistoryOptions(itemId));

  return (
    <ValidationHistoryContent
      history={history}
      defaultIsCollapsed={defaultIsCollapsed}
    />
  );
}
